var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer text-white"},[_vm._v(" Developed by "),_c('a',{attrs:{"href":"https://ultof.com","target":"_blank"}},[_vm._v("ULTOF.")]),_c('a',{staticClass:"footerSecondA",staticStyle:{"color":"#fff"}},[_vm._v("  All Rights Reserved! ")])])
}]

export { render, staticRenderFns }